<template>
	<div class="mr-2 mw-320px">
		<div class="flex">
			<h5 class="text-white text-lg font-bold mb-3">{{ name }}</h5>
		</div>

		<RecommendedAspectRatio :uploadBoxType="uploadPlace" />

		<span class="errormessage" :class="{ 'opacity-100': $page.props.errors[type] }"
		>{{ $page.props.errors[type] }}</span>

		<div v-if="!form.station_files[type].loaded_file_path" class="upload-box">
		    <span>
		    	<i class="icon-upload mr-2"></i><a href="##" @click.prevent="changeUploadBoxState(type)">Upload from media library</a>
		    </span>
		</div>

		<div v-if="form.station_files[type].loaded_file_path" class="upload-box w-310px relative">
            <div class="">
                <img :src="form.station_files[type].loaded_file_path" class="logo-img">
            </div>

            <div class="badge-buttons-wrapper">
	            <div class="badge-buttons shadow">
	                <button @click.prevent="() => changeUploadBoxState(type)"
	                title="Edit"><i class="pen"></i></button>
	                <button @click.prevent="() => deletePreviewImageOrLogo(type)"
	                title="Delete"><i class="trash"></i></button>
	            </div>
	        </div>

        </div>

	</div>
</template>

<script>
import RecommendedAspectRatio from '@/Pages/Media/RecommendedAspectRatio';
import {
	deletePreviewImageOrLogo,
	hasFileInNotFallbackLanguage,
	unlinkImageOrLogoInAllLanguages,
	unlinkImageOrLogoByLanguage,
	deleteInAllLanguagesFormRunning
} from '@/Pages/GlobalHelpers';

export default {
	components: {
        RecommendedAspectRatio
    },
	props: [
		'name',
		'type',
		'form',
		'file',
		'changeUploadBoxState',
		'uploadPlace',
		'current_language',
		'changeLanguage',
		'showPreventFallbackLangModal',
		'deleteInAllLanguagesFormRunning',
		'hidePreventFallbackLangModal'
	],
	data(){
		return {
			identifier: this.$page.props.station.data.id,
			entity: 'station',
			unlink_form: this.$inertia.form({
                _method: 'POST',
                type: null,
                current_language: null,

            }),
            files_for_delete_in_languages:[],
            number_of_language_for_file_to_delete: null,
		}
	},
	watch:{
        deleteInAllLanguagesFormRunning:deleteInAllLanguagesFormRunning,
    },
	methods:{
		//preview image and logo
        deletePreviewImageOrLogo:deletePreviewImageOrLogo,
        hasFileInNotFallbackLanguage:hasFileInNotFallbackLanguage,
        unlinkImageOrLogoInAllLanguages:unlinkImageOrLogoInAllLanguages,
        unlinkImageOrLogoByLanguage:unlinkImageOrLogoByLanguage,
	}
}
</script>